import type { UserRole } from "@/lib/permissions";

/** Public OPAC API guide is for admins and library staff integrators — not patrons. */
export function canViewIntegratorDocumentation(
  userRole: UserRole | undefined,
  options: { isTenantAdmin?: boolean } = {}
): boolean {
  if (userRole === "SUPER_ADMIN" || options.isTenantAdmin) return true;
  if (userRole === "LIBRARIAN" || userRole === "STAFF" || userRole === "TENANT_ADMIN") {
    return true;
  }
  return false;
}
